module.exports = __webpack_public_path__ + "static/phone-9fb58f68983fdf2b543f5678efb41e26.png";